export default __webpack_public_path__ + "static/media/experiencias.1f073277.svg";